// Dashboard subscriptions stay hidden until link emails (CAC-5726) and the send-time access
// check (CAC-5727) ship and the hourly send is switched on. Unset means off.
export function isDashboardSubscriptionsEnabled(): boolean {
  return import.meta.env.VITE_DASHBOARD_SUBSCRIPTIONS_ENABLED === 'true';
}
